import { FormaPagoEntity } from "./detalle_vehiculo_entity";

export class DetalleViviendaEntity {
    constructor(
        public CodigoUsuarioExtranet?:number,
        public CodigoProducto?:number,
        public CodigoCliente?:number,
        public CiudadCodigo?:number,
        public CodigoVivienda?:number,
        public CodigoPlan?:number,
        public CallePrincipal?:string,
        public Numeracion?:string,
        public CalleSecundaria?:string,
        public ValorAsegurado?:number,
        public TipoEstructura?:number,
        public Contenidos?:ContenidosVivienda[],
        public InicioVigencia?:Date,
        public FinVigencia?:Date,
        public CodigoEjecutivoCuenta?:number,
        public EsContenido?: boolean,
        public Observaciones?: string,
        public FormaPago?: FormaPagoEntity,
        public MantenerFormaPago?: boolean
    ){}
}

export class ContenidosVivienda{
    constructor(
        public Codigo?:number,
        public Detalle?:string,
        public Marca?:string,
        public Modelo?:string,
        public Valor?:number
    ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/detalle_vivienda.ts